define('lib/Podio.FormValidation',['require','underscore','jquery','moment','lib/jquery/jquery.validate','lib/jquery/jquery.timeentry','lib/Podio.Event','lib/Podio.Config','lib/Podio.Routes','bowser','translate'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var moment = require('moment');
  require('lib/jquery/jquery.validate');
  require('lib/jquery/jquery.timeentry');

  var podioEvent = require('lib/Podio.Event');
  var podioConfig = require('lib/Podio.Config');
  var podioRoutes = require('lib/Podio.Routes');
  var browser = require('bowser');
  var t = require('translate');

  function showInvalidIcon(domInput, errorMessage) {
    var elmInput = $(domInput);
    var elmParent = $.data(domInput, 'formValidationParent');
    var elmWrapperParent = elmInput.parents('.form-validation-use-wrapper');
    var elmErrorWrapper = elmInput.parents('.box-error-wrapper:first');
    var errorStyle = $(this.currentForm).data('error-style');
    var setFocus = false;

    if( document.activeElement == domInput ){
      setFocus = true;
    }

    if (elmInput.is(':checkbox') && !elmWrapperParent.length && errorStyle !== 'box-errors') {
      return;
    }

    if (elmInput.is('textarea') ) {
      elmInput.parent('.elastic-textarea.active').removeClass('active');
    }

    if (!elmParent) {
      elmParent = elmWrapperParent.length > 0 ? elmWrapperParent : elmInput.parent();
      $.data(domInput, 'formValidationParent', elmParent);
    }
    var elmWrapper;

    if (elmParent.hasClass('form-validation-use-wrapper')) {
      elmWrapper = elmParent.parent().filter('.form-validation-invalid-wrapper');
      if (!elmWrapper.length) {
        elmWrapper = $('<div />', { 'class' : 'form-validation-invalid-wrapper'});
        elmParent.wrapAll(elmWrapper);
        elmWrapper = elmParent.parent();
      }
    }
    else {
      elmWrapper = elmParent.find('.form-validation-invalid-wrapper');
      if (!elmWrapper.length) {
        elmWrapper = $('<div />', { 'class' : 'form-validation-invalid-wrapper'});
        elmInput.wrapAll(elmWrapper);
        elmWrapper = elmParent.find('.form-validation-invalid-wrapper');
      }
    }

    var elmErrorIcon = elmParent.find('.form-validation-invalid-icon');
    if (!elmErrorIcon.length) {
      elmErrorIcon = $('<label />', {
        'for'   : elmInput.attr('name') || elmInput.attr('id'),
        'class' : 'form-validation-invalid-icon icon-16 icon-16-red-warning-triangle tooltip',
        'title' : errorMessage
      });

      elmErrorIcon.addClass(this.settings.errorClass);
      elmErrorIcon.insertAfter(elmInput);

      var iconTopPos = (elmInput.outerHeight(true) / 2) - elmErrorIcon.height() / 2;
      if (elmInput.is('textarea')) {
        iconTopPos = 8;
      }

      elmErrorIcon.css({ 'top' : iconTopPos,  'right' : '8px', 'padding' : '0' });
    }

    if (errorStyle === 'box-errors') {
      elmErrorWrapper.addClass('error');
    }

    if( setFocus ) {
      elmInput.focus();
    }

    this.toShow = this.toShow.add(elmErrorIcon);
  }

  function passwordRating(password) {

    var email = document.getElementById('user_mail');
    if(email && password === email.value) {
      return "weak";
    }

    var minLength = 8;
    var maxLength = 256;
    var charTypes = [
      /[a-z]/.test(password),
      /[A-Z]/.test(password),
      /[0-9]/.test(password),
      /[^a-zA-Z0-9]/.test(password)
    ];

    var validCharTypesCount = _.reduce(charTypes, function(memo, value){
      if( value === true ) {
        return memo + 1;
      } else {
        return memo;
      }
    }, 0);

    if( (password.length < minLength)  || ( validCharTypesCount < 4 ) )  {
      return "weak";
    }

    if (password.length > maxLength )  {
      return "long";
    }

    if (password.length < minLength + 2) {
      return "fair";
    }

    if (validCharTypesCount > 3) {
      return "strong";
    }

  }

  function onInit() {

    // Password meter
    if (browser.msie && parseInt(browser.version, 10) === 10){
      var passwordInputElement = $('input.password').get(0);
      if (passwordInputElement) {
        passwordInputElement.addEventListener('keyup', onInputPasswordInput, false);
      }
    } else {
      $('input.password').on('input', onInputPasswordInput);
    }

    // Custom validation methods
    $.extend($.validator.messages, {
      required: t("This field is required. #validation"),
      remote: t("Please fix this field. #validation"),
      email: t("Please enter a valid email address. #validation"),
      url: t("Please enter a valid URL. (ex http://podio.com) #validation"),
      date: t("Please enter a valid date. #validation"),
      dateISO: t("Please enter a valid date (ISO). #validation"),
      number: t("Please enter a valid number. #validation"),
      digits: t("Please enter only digits. #validation"),
      creditcard: t("Please enter a valid credit card number. #validation"),
      equalTo: t("Please enter the same value again. #validation"),
      accept: t("Please enter a value with a valid extension. #validation"),
      maxlength: $.validator.format(t("Please enter no more than {0} characters. #validation")),
      minlength: $.validator.format(t("Please enter at least {0} characters. #validation")),
      rangelength: $.validator.format(t("Please enter a value between {0} and {1} characters long. #validation")),
      range: $.validator.format(t("Please enter a value between {0} and {1}. #validation")),
      max: $.validator.format(t("Please enter a value less than or equal to {0}. #validation")),
      endDateTime: t('The end time must be later than the start time. #validation'),
      endTimeRequired: t('You have to specify an end time if the start time is set and the end and start date are equal #validation'),
      endTimeRequiresStartTime: t('You have to specify a start time if you specify an end time #validation'),
      equalToData: t("Wrong text entered. #validation"),
      letterswithbasicpunc: t("Letters or punctuation only please. #validation"),
      required_group: t("Please enter a value in one of them. #validation"),
      required_group_by_name: t("Please enter a value in at least one field. #validation"),
      required_checkbox_group: t("Select at least one option. #validation"),
      'required-first-or-empty': t("Please enter a name or remove other contact data #validation"),
      imageFile: t("You file has a non-supported image format. Only jpg/png/gif/bmp are supported. #validation"),
      money_value: t('Please select a currency #validation'),
      required_embed: t("This field is required. #validation"),
      required_location: t("This field is required. #validation"),
      required_tinymce: t("This field is required. #validation"),
      required_subdomain: t("Please enter a valid domain. #validation"),
      required_domain: t("Please enter a valid domain. #validation"),

      localeAwareDate: t("Please enter a valid date. #validation"),
      localeAwareNumber: t("Please enter a valid number. #validation"),

      password: t('You must enter a valid password into this field #passwordstrength')
    });

    $.validator.addMethod('localeAwareDate', function(value, element) {
      return this.optional(element) || podioConfig.localeSettings.validations.date_regexp.test(value);
    });

    $.validator.addMethod('localeAwareNumber', function(value, element) {
      return this.optional(element) || podioConfig.localeSettings.validations.number_regexp.test(value);
    });

    $.validator.addMethod("letterswithbasicpunc", function(value, element) {
      return this.optional(element) || /^[a-z\-.,()'\"\s]+$/i.test(value);
    });

    $.validator.addMethod('required_subdomain', function(value, element) {
      return (/^[a-z0-9\/\-]+$/i).test(value);
    });

    $.validator.addMethod('required_domain', function(value, element) {
      return (/^[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i).test(value);
    });

    $.validator.addMethod('endDateTime', function(value, element) {
      var intervalPartEnd = $(element).parents('.interval-part:first');
      var intervalPartStart = intervalPartEnd.siblings('.interval-part.start-date:first');

      var endTime = $(element).timeEntry('getTime');
      var endDate = intervalPartEnd.find('.date-field').datepicker('getDate');
      var startTime = intervalPartStart.find('.time-field').timeEntry('getTime');
      var startDate = intervalPartStart.find('.date-field').datepicker('getDate');

      return !endTime || !endDate || !startTime || !startDate || moment(startDate).diff(moment(endDate)) !== 0 || moment(endTime) >= moment(startTime);
    });

    $.validator.addMethod('endTimeRequired', function(value, element) {
      var intervalPartEnd = $(element).parents('.interval-part:first');
      var intervalPartStart = intervalPartEnd.siblings('.interval-part.start-date:first');

      var endTime = $(element).timeEntry('getTime');
      var endDate = intervalPartEnd.find('.date-field').datepicker('getDate');
      var startTime = intervalPartStart.find('.time-field').timeEntry('getTime');
      var startDate = intervalPartStart.find('.date-field').datepicker('getDate');

      return (startTime && startDate && endDate && moment(startDate).diff(moment(endDate)) === 0) ? endTime : true;
    });

    $.validator.addMethod('endTimeRequiresStartTime', function(value, element) {
      var intervalPartStart = $(element).parents('.interval-part:first');
      var intervalPartEnd = intervalPartStart.siblings('.interval-part.end-date:first');

      var startTime = $(element).timeEntry('getTime');
      var endTime = intervalPartEnd.find('.time-field').timeEntry('getTime');

      return !!endTime ? !!startTime : true;
    });

    $.validator.addMethod('numberComma', function(value, element) {
      return this.optional(element) || /^-?(?:\d+|\d{1,3}(?:\.\d{3})+)(?:,\d+)?$/.test(value);
    });

    $.validator.addMethod('equalToData', function(value, element) {
      return value == $(element).data('validation');
    });

    $.validator.addMethod('required_group', function(val, element) {
      var valid = $('.required_group', element.form).filter(
        function() {
          return $(this).val().trim().length > 0;
        }).length >= 1;

      if (!$(element).data('reval')) {
        var fields = $('.required_group', element.form);
        fields.removeClass('error');
        //fields.data('reval', true).valid();
        fields.data('reval', false);
      }
      return valid;
    });

    $.validator.addMethod('required_group_by_name', function(val, element) {
      var name = $(element).attr('name').replace(/\[[\w]+\]/gi, '');
      return $('[name^=' + name + ']', element.form).filter(
        function() {
          return $(this).val().trim().length > 0;
        }).length >= 1;
    });

    $.validator.addMethod('required-first-or-empty', function(val, element) {
      var parent = $(element).parents('.contact-fields:first');
      var onefilled = false;
      parent.find('input:not(:first)').each(function() {
        onefilled = onefilled || $(this).val().length > 0;
      });
      if (onefilled) {
        return parent.find('input:first').val().length > 0;
      } else {
        return true;
      }
    });

    $.validator.addMethod('required_checkbox_group', function(val, element) {
      var name = $(element).attr('name').replace(/\[\]/, '');
      return $("[name^='" + name + "']:checked", element.form).length >= 1;
    });

    $.validator.addMethod('imageFile', function(val, element) {
      if (!val.length) {
        return true;
      }
      return new RegExp(/^.+\.(jpg|jpeg|gif|png|bmp)$/i).test(val);
    });

    $.validator.addMethod('money_value', function(val, element) {
      if ($(element).val().length) {
        return $(element).parents('.inline-editable-money:first').find('select').val().length;
      } else {
        return true;
      }
    });

    $.validator.addMethod('required_embed', function(val, element) {
      var elmPreview = $(element).parents('.embed-wrapper').find('.embed-data');
      return elmPreview.length ? true : false;
    });

    $.validator.addMethod('required_location', function(val, element) {
      var elmLocationAddresses = $(element).parents('.location-wrapper').find('input[type="hidden"]:not(".required_location")');
      return elmLocationAddresses.length ? true : false;
    });

    $.validator.addMethod('required_tinymce', function(val, element) {
      var elmEditor = $(element);
      var editor = $.data(elmEditor.get(0), 'texteditor');

      if(editor) {
        editor.execCommand('mceAddUndoLevel');
      }

      if (elmEditor.val().stripHtml().trim().length > 0) {
        return true;
      } else {
        return false;
      }
    });


    // Password strength validation
    $.validator.addMethod("password", function(value, element) {
      var rating = passwordRating(value);

      return (rating != 'weak') && (rating != 'long');
    });

    // Email validation with remote call to API
    function remoteEmailValidator(value, element) {
      var self = this;
      var $elm = $(element);
      var email = $(element).val();

      $elm.addClass("loading");
      $elm.trigger("validation:email:start", element, value);

      var xhr = $.ajax({
        url: podioRoutes.validations_email_path(),
        type: "post",
        dataType: "json",
        data: {
          email: email
        },
        beforeSend: function(xhr) { xhr.setRequestHeader('X-CSRF-Token', podioConfig.authenticity_token()); }
      }).then(function(response) {
        $elm.removeClass("loading");
        var valid = true;
        var data = { valid: true, suggestions: [] };

        if(response.status === "error") {
          // Fall back to standard email validation on errors, e.g. rate limitation
          data.valid = $.validator.methods.email.call(self, value, element);
        } else {
          data = response.data.object;
        }

        $elm.trigger("validation:email:result", data);

        return data.valid;
      });

      return "pending";
    }

    $.validator.addMethod("remote_email", function(value, element) {
      // create debounced function in context of validator
      if(!this._debouncedRemoteEmailValidator) {
        this._debouncedRemoteEmailValidator = _.debounce(remoteEmailValidator, 500);
      }

      // use previous validity status if debounced
      var valid = this._debouncedRemoteEmailValidator.call(this, value, element);
      return _.isUndefined(valid) ? this.previousValue(element).valid : valid;
    });

    $.validator.addClassRules({
      'endDateTime': { endDateTime: true },
      'endTimeRequired' : { endTimeRequired: true },
      'equalToData': {equalToData: true},
      'required_group': {required_group: true},
      'required_group_by_name': {required_group_by_name: true},
      'required_checkbox_group': {required_checkbox_group: true},
      'required_embed' : { required_embed: true },
      'required_location' : { required_location: true },
      'required_tinymce' : { required_tinymce: true },
      'required_subdomain' : { required_subdomain: true },
      'required_domain' : { required_domain: true },

      'localeAwareDate' : {localeAwareDate: true},
      'localeAwareNumber' : {localeAwareNumber: true},

      'password' : { password: true },

      'remote_email' : { remote_email: true }
    });

    $.extend($.validator.prototype, {
      showLabel : showInvalidIcon,
      hideErrors: function() {

        var elmBoxWrapper = $(this.toHide).parents('.box-error-wrapper');
        elmBoxWrapper.removeClass('error');

        var elmErrorIcons = $(this.lastActive).parent('.form-validation-invalid-wrapper').find('.form-validation-invalid-icon');
        elmErrorIcons.hide();

        this.addWrapper(this.toHide).hide();
      }
    });

    $('form.enable-form-validation').each(function() {
      initValidation($(this));
    });

  }

  function onInputPasswordInput(e) {
    var elmTarget = $(this);
    var inputName = elmTarget.attr('name') || elmTarget.attr('id');
    var value = elmTarget.val();
    var rating = passwordRating(value);
    var messages = {
      "weak": t("Weak (Min. 8 letters & numbers) #passwordstrength"),
      "long": t("Too long (Max 256 characters) #passwordstrength"),
      "fair": t("Fair #passwordstrength"),
      "strong": t("Strong #passwordstrength")
    };

    var elmForm = elmTarget.parents('form');
    var elmMeter = elmForm.find( ".password-meter[data-for='{0}']".format(inputName) );
    var elmMeterLabel = elmMeter.find('.label');

    elmMeter.removeAttr('class');
    elmMeter.addClass('password-meter');
    elmMeter.addClass(rating);
    elmMeterLabel.text( messages[rating] );
  }

  function removeErrorsTheHardWay(elmField) {
    elmField.removeClass('error');
    elmField.find('.box-error-wrapper').removeClass('error');
    $('.form-validation-invalid-icon', elmField).remove();
  }

  function initValidation(elmForm, options) {
    if (!elmForm) {
      return;
    }

    var validatorOptions = $.extend(options, {});

    // Don't focus invalid element when form is inside a modal, it can make the page scroll
    if (_.isUndefined(validatorOptions.focusInvalid)) {
      var isInModal = elmForm.parents('.modal-content:first').length > 0;
      if (isInModal) {
        validatorOptions.focusInvalid = false;
      }
    }

    return elmForm.validate(validatorOptions);
  }

  function destroy(elmForm) {
    elmForm.validate().resetForm();
    $.removeData(elmForm[0], 'validator');
  }

  podioEvent.bind(podioEvent.Types.init, onInit);

  return {
    init:initValidation,
    destroy : destroy,
    removeErrors: removeErrorsTheHardWay
  };
});

